import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import '../styles/mudatagridcustomstyle.css';
import axios from 'axios';
import MaterialNotifyComponent from './MaterialNotifyComponent';
import { getAuthenticationToken } from '../utils/TokenHandler';
import { Backdrop, CircularProgress } from '@mui/material';
import MainPageCompenent from './MainPageCompenent';

const columns = [
    {
        field: 'id',
        headerName: '#',
        editable: false,
        flex: 1
    },
    {
        field: 'ticketDate',
        headerName: 'تاریخ ارسال پیام',
        editable: false,
        flex: 2,
    },
    {
        field: 'ticketTitle',
        headerName: 'عنوان پیام',
        editable: false,
        flex: 3,
    },
    {
        field: 'ticketBody',
        headerName: 'متن پیام',
        editable: false,
        flex: 8,
    },
];

function ScoreList(props) {
    const [customerSupportSystemTicketing, setCustomerSupportSystemTicketing] = useState([]);
    const [messageNotify, setMessageNotify] = useState({ severity: "error", message: "", open: false });
    const [open, setOpen] = useState(false);
    useEffect(() => {
        const url = 'api/v1/SupportSystemTicketing/GetCustomerSupportSystemTicketing';
        const urlParams = {
            params:
            {
                CustomerId: getAuthenticationToken().userID,
                SupportSystemTicketingType: 1
            }
        };
        setOpen(true);
        axios.get(url, urlParams).then((response) => {
            setCustomerSupportSystemTicketing(response.data);
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در فراخوانی اطلاعات از سرور",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        });
    }, []);

    return (customerSupportSystemTicketing !== null) && (

        <MainPageCompenent>
            <DataGrid className={'rtl-grid'}
                rows={customerSupportSystemTicketing}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                direction="row-reverse"
                disableSelectionOnClick
                disableColumnMenu
                exportDataAsCsv={(e) => console.log('exportDataAsCsv', e)}
            />
            <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </MainPageCompenent>
    );
}

export default ScoreList;